<div *ngIf='dataNavVisible' fxLayout='row' class='report-data-nav-container'>
  <button
    mat-button
    vrm-button
    class='data-nav-back'
    fxLayout='row'
    fxLayoutAlign='center center'
    (click)='prevData()'
    [disabled]='currentIndex <= minIndex'
  >
    <mat-icon>arrow_back</mat-icon>
  </button>

  <div fxFlex class='nav-data-dropdown-container'>
    <div fxFlex fxLayout='row' fxLayoutAlign='center' *ngIf='selectedFilterData'>
      <button type='button' mat-button [matMenuTriggerFor]='subReportFilters'>
        <span *ngIf='currentReport' style='position: relative; bottom: 1px'>{{ currentReport }}: </span>
        {{ selectedFilterData.text | filterTextTransform }}
        <mat-icon style='position: relative; bottom: 2px'>arrow_drop_down</mat-icon>
      </button>
      <mat-menu class='mat-menu--dynamic-height' #subReportFilters [overlapTrigger]='false'>
        <button
          type='button'
          mat-menu-item
          *ngFor='let dataFilter of dataFilterOptions; let i = index'
          (click)='dataFilterChanged(dataFilter, i)'
          [class.bold]='dataFilter.value === selectedFilterData.value'
        >
          {{ dataFilter.text | filterTextTransform }}
        </button>
      </mat-menu>
    </div>
  </div>

  <button
    mat-button
    vrm-button
    class='data-nav-forward'
    fxLayout='row'
    fxLayoutAlign='center center'
    (click)='nextData()'
    [disabled]='currentIndex >= maxIndex'
  >
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
